import { useManualAuthoringStore } from "../../store/manualAuthoringStore";

export default function ManualStructureEditor() {
  const manual = useManualAuthoringStore((s) => s.presentManual);

  const updateSectionTitle = useManualAuthoringStore((s) => s.updateSectionTitle);
  const updateSubSectionTitle = useManualAuthoringStore((s) => s.updateSubSectionTitle);

  const selectSection = useManualAuthoringStore((s) => s.selectSection);
  const selectSubSection = useManualAuthoringStore((s) => s.selectSubSection);

  const selectedSectionId = useManualAuthoringStore((s) => s.selectedSectionId);
  const selectedSubSectionId = useManualAuthoringStore((s) => s.selectedSubSectionId);

  return (
    <div className="bg-white border rounded p-3">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h5 className="mb-1">Edit Structure</h5>
          <div className="text-muted small">Organize sections and subsections</div>
        </div>
      </div>

      {manual.sections.length === 0 ? (
        <div className="text-muted">No sections available. Use the actions panel to add a section.</div>
      ) : (
        <div className="d-flex flex-column gap-2">
          {manual.sections.map((section) => {
            const sectionSelected = selectedSectionId === section.id && !selectedSubSectionId;

            return (
              <div
                key={section.id}
                className={`border rounded p-2 ${sectionSelected ? "border-primary" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={() => selectSection(section.id)}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="badge text-bg-secondary">Section</span>
                  <input
                    className="form-control"
                    value={section.title}
                    onClick={(e) => {
                      e.stopPropagation();
                      selectSection(section.id);
                    }}
                    onChange={(e) => updateSectionTitle(section.id, e.target.value)}
                  />
                </div>

                {section.subSections?.length ? (
                  <div className="mt-2 ms-4 d-flex flex-column gap-2">
                    {section.subSections.map((sub) => {
                      const subSelected =
                        selectedSectionId === section.id && selectedSubSectionId === sub.id;

                      return (
                        <div
                          key={sub.id}
                          className={`border rounded p-2 ${subSelected ? "border-primary bg-light" : ""}`}
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectSubSection(section.id, sub.id);
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <span className="badge text-bg-light border">Sub</span>
                            <input
                              className="form-control"
                              value={sub.title}
                              onClick={(e) => {
                                e.stopPropagation();
                                selectSubSection(section.id, sub.id);
                              }}
                              onChange={(e) =>
                                updateSubSectionTitle(section.id, sub.id, e.target.value)
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
